//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";

var debounce = require("lodash.debounce");

export function AvaliacaoM() {
  const token = localStorage.getItem("token") || "";

  const [answers,setAnswers] = useState({});


  


  return (
    <div className="row">
      <div className="col-12">

      <div className={"py-5 px-3"}>
      <div className={ "card-body"} id="card">
      <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              AVALIAÇÃO
            </h4>
            <br></br>
            <br></br>

            {/* <p>texto avaliação</p> */}

            <Link to={'/manutenibilidade/avaliacao/modularidade'}><button className="btn btn-outline-primary btn-lg w-100"> 
            Modularidade
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/manutenibilidade/avaliacao/documentalidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Documentalidade
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/manutenibilidade/avaliacao/disponibilidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Disponibilidade
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/manutenibilidade/avaliacao/modificabilidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Modificabilidade
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/manutenibilidade/avaliacao/testabilidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Testabilidade
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/manutenibilidade/avaliacao/legibilidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Legibilidade
                        </button></Link>
                        <br/>
                        <br/>
            
            
            
            
                        




                









      </div>
      </div>
      </div>

    </div>
  );
}
